export default __webpack_public_path__ + "assets/7e33bc22c60abb61f05eccfffc732829.jpg";